export default {
  CREATE_BACKGROUND_ACTION: 'createBackgroundAction',
  CANCEL_BACKGROUND_ACTION: 'cancelBackgroundAction',
  CLEAR_BACKGROUND_ACTION_LIST: 'clearBackgroundActionList',
  CLEAR_NEW_ACTIONS_NUMBER: 'clearNewActionsNumber',
  CREATE_BACKGROUND_ACTION_AND_CHECK_STATUS: 'createBackgroundActionAndCheckStatus',
  CREATE_OR_UPDATE_BACKGROUND_ACTION: 'createOrUpdateBackgroundAction'
}
